import type { CallOutcome } from '../systems/EventBus';

export interface CallOption {
  text: string;
  customerResponse: string;
  outcome?: CallOutcome;
  nextStep?: number;
  ptpSuggestion?: { amount: number; date: string };
}

export interface CallStep {
  customerSays: string;
  options: readonly CallOption[];
}

export interface CollectionsScenario {
  id: string;
  customer: string;
  callerName: string;
  reason: string;
  steps: readonly CallStep[];
}

export const ATLAS_TRADING_CALL: CollectionsScenario = {
  id: 'call-atlas-001',
  customer: 'Atlas Trading',
  callerName: 'Marcus Gomez',
  reason: '92 days past due — $14,500 outstanding',
  steps: [
    {
      customerSays:
        "Hi, this is Marcus Gomez at Atlas Trading. Look — I know we're past due. We've had a rough quarter.",
      options: [
        {
          text: "Thanks for calling. What's your timeline to clear the balance?",
          customerResponse:
            "Honestly? Cash flow is tight. I can probably do something this month, but I'd need to check with my CFO.",
          nextStep: 1,
        },
        {
          text: 'Per our terms, this account is heading to collections referral.',
          customerResponse:
            "Whoa — let's not do that. Look, I really can't promise a hard date. Best I can do is 'soon.' We'll be in touch.",
          nextStep: 2,
        },
        {
          text: 'Can you commit to anything today?',
          customerResponse:
            "Honestly? Cash flow is tight. I can probably do something this month, but I'd need to check with my CFO.",
          nextStep: 1,
        },
      ],
    },
    {
      customerSays:
        "Honestly? Cash flow is tight. I can probably do something this month, but I'd need to check with my CFO.",
      options: [
        {
          text:
            'I understand. Can we schedule a partial payment by Friday and the rest end-of-month?',
          customerResponse:
            "Yeah — let's do $5K Friday and the rest by end of month. I'll send a confirmation email.",
          outcome: 'success',
          ptpSuggestion: { amount: 5000, date: 'This Friday' },
        },
        {
          text: "Walk me through what's possible. What can you commit to right now?",
          customerResponse:
            "I really can't promise a hard date. Best I can do is 'soon.' We'll be in touch.",
          nextStep: 2,
        },
        {
          text: 'Can you wire something today, even partial?',
          customerResponse:
            "Maybe. Let me see what I can move. I'd say within the week, but no specific number yet.",
          outcome: 'partial_success',
          ptpSuggestion: { amount: 0, date: 'Within 30 days' },
        },
      ],
    },
    {
      customerSays:
        "I really can't promise a hard date. Best I can do is 'soon.' We'll be in touch.",
      options: [
        {
          text: "Soon doesn't work. I need a date by end of business.",
          customerResponse:
            "Then we'll have to take this offline. I'll call you back.",
          outcome: 'fail',
        },
        {
          text:
            "Okay — let me note 'within 30 days, amount TBD' for now and follow up Friday.",
          customerResponse:
            "That works. I'll be in touch by Friday with a real number.",
          outcome: 'partial_success',
          ptpSuggestion: { amount: 0, date: 'Within 30 days' },
        },
        {
          text: "If you can wire $5K by Friday, I'll hold off on collections referral.",
          customerResponse:
            'Yeah, $5K by Friday — I can make that happen. Let me get my CFO on it.',
          outcome: 'success',
          ptpSuggestion: { amount: 5000, date: 'This Friday' },
        },
      ],
    },
  ],
};
